import { Title } from './Title';
import { Text } from './Text';
import { Paragraph } from './Paragraph';
import LinkText from './LinkText';
export var Typography = {
  Title: Title,
  Text: Text,
  Paragraph: Paragraph,
  LinkText: LinkText
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vVHlwb2dyYXBoeS9pbmRleC50c3giXSwibmFtZXMiOlsiVGl0bGUiLCJUZXh0IiwiUGFyYWdyYXBoIiwiTGlua1RleHQiLCJUeXBvZ3JhcGh5Il0sIm1hcHBpbmdzIjoiQUFBQSxTQUFTQSxLQUFULFFBQXNCLFNBQXRCO0FBQ0EsU0FBU0MsSUFBVCxRQUFxQixRQUFyQjtBQUNBLFNBQVNDLFNBQVQsUUFBMEIsYUFBMUI7QUFDQSxPQUFPQyxRQUFQLE1BQXFCLFlBQXJCO0FBRUEsT0FBTyxJQUFNQyxVQUFVLEdBQUc7QUFDeEJKLEVBQUFBLEtBQUssRUFBTEEsS0FEd0I7QUFFeEJDLEVBQUFBLElBQUksRUFBSkEsSUFGd0I7QUFHeEJDLEVBQUFBLFNBQVMsRUFBVEEsU0FId0I7QUFJeEJDLEVBQUFBLFFBQVEsRUFBUkE7QUFKd0IsQ0FBbkIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBUaXRsZSB9IGZyb20gJy4vVGl0bGUnO1xuaW1wb3J0IHsgVGV4dCB9IGZyb20gJy4vVGV4dCc7XG5pbXBvcnQgeyBQYXJhZ3JhcGggfSBmcm9tICcuL1BhcmFncmFwaCc7XG5pbXBvcnQgTGlua1RleHQgZnJvbSAnLi9MaW5rVGV4dCc7XG5cbmV4cG9ydCBjb25zdCBUeXBvZ3JhcGh5ID0ge1xuICBUaXRsZSxcbiAgVGV4dCxcbiAgUGFyYWdyYXBoLFxuICBMaW5rVGV4dFxufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/common/Typography/index.js
// module id = 487
// module chunks = 118